import MainLayout from '@/common/components/layouts/MainLayout';
import SignatureContainer from '@/modules/adjusterReportModules/components/signatureContainer/SignatureContainer';

export default ({ editable }: { editable: boolean }) => {
  return (
    <MainLayout
      title="زیان دیده / تصاویر"
      header="titleHeader"
      hasBottomPadding
    >
      <SignatureContainer type="PropertyDamaged" editable={editable} />
    </MainLayout>
  );
};
